import { ChangeDetectionStrategy, Component, computed, inject, signal, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IOnboardingStepNotification } from '../../fi-onboarding';
import { cloneDeep, isEqual } from '@fi-shared/utils';
import { FiDialogCloseReason } from '@fi-app/shared/fi-dialogs/fi-dialogs-close-reason';
import { FiOnboardingAutomatedNotificationHelperService } from './fi-onboarding-automated-notification-helper.service';
@Component({
    selector: 'fi-onboarding-automated-notification-dialog',
    templateUrl: './fi-onboarding-automated-notification-dialog.component.html',
    styleUrls: ['./fi-onboarding-automated-notification-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-automated-notification-dialog' },
    standalone: false,
})
export class FiOnboardingAutomatedNotificationDialogComponent extends FiDialogsContentBase<
    IOnboardingStepNotification[],
    IOnboardingStepNotification[]
> {
    private fiOnboardingAutomatedNotificationHelperService = inject(FiOnboardingAutomatedNotificationHelperService);

    protected notifications = signal<IOnboardingStepNotification[]>(cloneDeep(this.data));
    protected nonParticipantsNotifications = computed(() =>
        this.fiOnboardingAutomatedNotificationHelperService.getNonParticipantsNotification(this.notifications()),
    );
    protected participantsNotifications = computed(() =>
        this.fiOnboardingAutomatedNotificationHelperService.getParticipantsNotification(this.notifications()),
    );

    protected closeDialog(): void {
        this.dialogRef.close({ reason: FiDialogCloseReason.YesButton, value: this.getResult() });
    }

    protected deleteNotification(notificationToDelete: IOnboardingStepNotification) {
        this.notifications.update((current) =>
            current.filter((notification) => !isEqual(notification, notificationToDelete)),
        );
    }

    protected openAddNotificationDialog(isParticipants: boolean): void {
        this.fiOnboardingAutomatedNotificationHelperService
            .openNotificationDialog(undefined, isParticipants)
            .onYesButtonClick((result: IOnboardingStepNotification) => {
                this.notifications.update((current) => [...current, result]);
            });
    }

    protected openEditNotificationDialog(
        notificationToEdit: IOnboardingStepNotification,
        isParticipants: boolean,
    ): void {
        this.fiOnboardingAutomatedNotificationHelperService
            .openNotificationDialog(notificationToEdit, isParticipants)
            .onYesButtonClick((result: IOnboardingStepNotification) => {
                this.notifications.update((current) =>
                    current.map((notification) => (isEqual(notification, notificationToEdit) ? result : notification)),
                );
            });
    }

    public getResult(): IOnboardingStepNotification[] {
        return this.notifications();
    }
}
